function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 37 41"
}, props), React.createElement("defs", null, React.createElement("path", {
  d: "M36.064 25.662c0 9.188-7.787 16.588-17.339 16.588-9.551 0-17.34-7.4-17.34-16.588S9.175 9.074 18.726 9.074c9.552 0 17.34 7.4 17.34 16.588zm-4.5 0c0-6.65-5.723-12.088-12.839-12.088-7.116 0-12.84 5.438-12.84 12.088 0 6.65 5.724 12.088 12.84 12.088s12.84-5.438 12.84-12.088zM16.5 4.706a2.25 2.25 0 114.5 0v4.412a2.25 2.25 0 01-4.5 0V4.706zm6.893-2.25a2.25 2.25 0 110 4.5h-9.286a2.25 2.25 0 110-4.5h9.286zM5.593 5.28a2.25 2.25 0 013.1 3.262L4.05 12.955a2.25 2.25 0 01-3.1-3.263l4.643-4.411zm10.91 15.6a2.25 2.25 0 014.5 0v9.422a2.25 2.25 0 11-4.5 0v-9.421z",
  id: "a"
})), React.createElement("use", {
  fill: "#969EA2",
  xlinkHref: "#a",
  transform: "translate(0 -2)"
})));